import React from 'react';
import {
  LinkProps as CsLinkProps,
  Link as CsLink,
} from '@cloudscape-design/components';
import { useNavigate } from 'react-router-dom';

export type LinkProps = Exclude<CsLinkProps, 'onClick'> & {
  href: string;
};

export const Link: React.FC<LinkProps> = (props) => {
  const navigate = useNavigate();
  return (
    <CsLink
      {...props}
      onFollow={(event) => {
        if (!props.external) {
          event.preventDefault();
          navigate(props.href);
        }
      }}
    >
      {props.children}
    </CsLink>
  );
};
